import React from "react";
import { Button } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import classes from "./ChannelSubmit.scss";
import { useChannelInfoOptions } from "./ChannelContext";

const EditChannelSubmit = ({ isUploading, onClose }) => {
  const { onEditChannelSubmit, errorValidation } = useChannelInfoOptions();

  const { t } = useI18n(["common"]);

  return (
    <div className={classes.container}>
      <Button variant="outlined-subtle" size="medium" onClick={onClose}>
        {t("common:cancel")}
      </Button>
      <Button
        size="medium"
        variant="progressive"
        disabled={errorValidation() || isUploading}
        onClick={onEditChannelSubmit}
      >
        {t("common:update")}
      </Button>
    </div>
  );
};

export default EditChannelSubmit;
